// extracted by mini-css-extract-plugin
export default {"elementCustom_tabPanel":"CustomizeStyles_elementCustom_tabPanel__rbyVV","elementCustom_tab":"CustomizeStyles_elementCustom_tab__Bi9Tq","menuItem":"CustomizeStyles_menuItem__eU8T7"};